import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.updateExternalLinks()
  }

  updateExternalLinks() {
    document.querySelectorAll('a').forEach(a => {
      if (a.hostname != location.hostname) {
        a.rel = 'noopener';
        a.target = '_blank';
      }
    });
  }
}
